<div class="drop-pin-modal-wrapper">
	<ng-template [cdkPortalOutlet]="mapPortal"></ng-template>
	<button (click)="centerOnCurrentLocation()" class="center-location-button" color="primary"
			mat-icon-button matTooltip="Center on your current location" matTooltipPosition="left">
		<mat-icon>my_location</mat-icon>
	</button>
	<div class="bottom" fxLayout="row" fxLayoutAlign="start" fxLayoutGap="15px">
		<button [color]="'accent'" mat-dialog-close mat-raised-button>
			Cancel
		</button>
		<button (click)="processLocation()" [color]="'primary'" mat-raised-button>
			Done
		</button>
	</div>
</div>
